import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  countrySelector,
  localeSelector,
} from '@xarvio/frontend-core-state/lib/intl/selectors';
import { getPublicAuthUrls } from './publicAuthUrls';

export const usePublicAuthUrls = () => {
  const country = useSelector(countrySelector);
  const locale = useSelector(localeSelector);

  return useMemo(
    () => getPublicAuthUrls({ country, locale }),
    [country, locale],
  );
};
